import { useToken } from '@/context/useToken';
import LoginRequired from '@/components/common/LoginRequired';
import Page from '@/components/layout/Page';
import Header from '@/components/layout/Header';
import Loader from '@/components/common/Loader';

import BookingsListForCoaches from './components/BookingsListForCoaches';
import BookingsListForClients from './components/BookingsListForClients';

import { useSelf } from '@/data/user';

const BookingListPage = () => {
  const self = useSelf();

  if (self.isLoading && !self.data) {
    return (
      <Page>
        <Header title="Bookings" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <Header title="Bookings" />
      {self.data.coach && <BookingsListForCoaches />}
      {!self.data.coach && <BookingsListForClients />}
    </Page>
  );
};

const BookingsLoader = () => {
  const { token } = useToken();

  if (!token) {
    return (
      <Page>
        <div className="flex justify-center items-center h-screen">
          <div className="text-center">
            <LoginRequired
              title="Bookings"
              message="You can view your bookings once you've logged in."
            />
          </div>
        </div>
      </Page>
    );
  }

  return <BookingListPage />;
};

export default BookingsLoader;
